import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const ShopContext = createContext(null);

export const ShopProvider = ({ children }) => {
  const { user } = useAuth();
  const [allShops, setAllShops] = useState([]);
  const [activeShopId, setActiveShopId] = useState(localStorage.getItem("activeShopId") || "");

  const refresh = async () => {
    try {
      const res = await api.get("/shops");
      setAllShops(res.data);
    } catch {}
  };

  useEffect(() => { refresh(); }, []);

  // Filter shops to only those user has access to
  const shops = (() => {
    if (!user) return allShops;
    if (user.role === "admin") return allShops; // admin sees all
    const allowed = user.shop_access || [];
    return allShops.filter((s) => allowed.includes(s.shop_id));
  })();

  // Ensure activeShopId is valid for this user
  useEffect(() => {
    if (shops.length === 0) return;
    if (!shops.find((s) => s.shop_id === activeShopId)) {
      const first = shops[0].shop_id;
      setActiveShopId(first);
      localStorage.setItem("activeShopId", first);
    }
  }, [shops, activeShopId]);

  const setShop = (id) => {
    setActiveShopId(id);
    localStorage.setItem("activeShopId", id);
  };

  const activeShop = shops.find((s) => s.shop_id === activeShopId) || shops[0];

  return (
    <ShopContext.Provider value={{ shops, activeShop, activeShopId: activeShop?.shop_id || activeShopId, setShop, refresh }}>
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
